import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Hook customizado para gerenciar mensagens rotativas durante o loading da IA
 * @param {boolean} isLoading - Se está carregando
 * @param {number} interval - Intervalo entre as mensagens em ms (padrão: 2500ms)
 * @returns {string} - Mensagem atual a ser exibida
 */
export const useAiLoadingMessages = (isLoading, interval = 2500) => {
  const { t } = useTranslation();
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  // Array com as chaves das mensagens que vão rodar
  const messageKeys = [
    "ai_loading.messages.reading_updates",
    "ai_loading.messages.analyzing_data",
    "ai_loading.messages.summarizing_findings",
    "ai_loading.messages.preparing_insights",
    "ai_loading.messages.reviewing_initiatives",
    "ai_loading.messages.generating_content",
  ];

  useEffect(() => {
    if (!isLoading) {
      setCurrentMessageIndex(0);
      return;
    }

    const intervalId = setInterval(() => {
      setCurrentMessageIndex(
        (prevIndex) => (prevIndex + 1) % messageKeys.length,
      );
    }, interval);

    return () => clearInterval(intervalId);
  }, [isLoading, interval, messageKeys.length]);

  if (!isLoading) {
    return "";
  }

  return t(messageKeys[currentMessageIndex]);
};
